import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { changeDateManual } from '../../../../../actions/bookingCalendar/date/changeDateRange'
import {
  getFromDate,
  getIsFullyLoaded,
  getScrollableFromDate,
  getScrollableToDate,
  getToDate,
} from '../../../../../reducers/bookingCalendar/selectors/dates'
import { IStore } from '../../../../../reducers'
import manuallySetPriceGridDate from '../../../../../actions/price/manuallySetPriceGridDate'
import MobileDatePicker, {
  IMobileDatePickerDispatch,
  IMobileDatePickerProps,
} from './MobileDatePicker'

const mapStateToProps = (state): IMobileDatePickerProps => ({
  finishDate: getToDate(state),
  maxDate: getIsFullyLoaded(state) ? null : getScrollableToDate(state),
  minDate: getIsFullyLoaded(state) ? null : getScrollableFromDate(state),
  startDate: getFromDate(state),
})

const mapDispatchToProps = (dispatch: Dispatch): IMobileDatePickerDispatch => ({
  changeDate: (startDate: Date) => {
    return dispatch(changeDateManual(startDate))
  },
})

const mapStateToPropsGrid = (state: IStore): IMobileDatePickerProps => ({
  finishDate: state.price.finishDate,
  startDate: state.price.startDate,
})

const mapDispatchToPropsGrid = (
  dispatch: Dispatch,
): IMobileDatePickerDispatch => ({
  changeDate: (startDate: Date) => {
    dispatch(manuallySetPriceGridDate(startDate))
  },
})

export const MobileGridPriceDatePicker = connect<any, any, any>(
  mapStateToPropsGrid,
  mapDispatchToPropsGrid,
)(MobileDatePicker)

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MobileDatePicker)
